import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'

import type { RankingTableColumn } from '../../types'
import type { TableOpt } from '@/components/cmTable/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ranking-table',
  props: {
    data: {},
    columns: {},
    hideRank: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { t, locale } = useI18n()
const props = __props

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  const rankCol = { prop: 'rank', label: t('overviewZone.rankColumn'), width: 60, columnOpt: { align: 'center' } }
  const dataCols = props.columns.map(col => ({
    prop: col.prop,
    label: col.label,
    width: col.width,
    minWidth: col.minWidth,
    columnOpt: col.columnOpt
  }))
  return {
    showSearch: false,
    showForm: false,
    showActionBar: false,
    showRightToolbar: false,
    hiddenPageTool: true,
    headerStyle: {
      transparent: true,
      showBorder: false
    },
    height: '100%',
    columns: props.hideRank ? dataCols : [rankCol, ...dataCols]
  }
})

function getRankClass(rank: number): string {
  if (rank <= 3) {
    return `rank-${rank}`
  }
  return 'rank-inactive'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CmTable, {
    tableOpt: tableOpt.value,
    data: _ctx.data
  }, _createSlots({ _: 2 }, [
    (!_ctx.hideRank)
      ? {
          name: "rank",
          fn: _withCtx((rankSlotProps) => [
            _createElementVNode("div", {
              class: _normalizeClass(["rank-badge", getRankClass((rankSlotProps as any).value)])
            }, _toDisplayString((rankSlotProps as any).value), 3)
          ]),
          key: "0"
        }
      : undefined,
    _renderList(_ctx.columns, (column) => {
      return {
        name: column.prop,
        fn: _withCtx((slotProps) => [
          (column.formatter)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(column.formatter), {
                key: 0,
                row: (slotProps as any).row,
                value: (slotProps as any).value
              }, null, 8, ["row", "value"]))
            : _createCommentVNode("", true)
        ])
      }
    })
  ]), 1032, ["tableOpt", "data"]))
}
}

})